import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { useConnectorFilePicker } from '#pplx/frontend/apps/ask/connectors-file-pickers/useConnectorFilePicker.js';
import { useFileConnectorUrl } from '#pplx/frontend/apps/ask/connectors/hooks/useFileConnectorUrl.js';
import { fileUploadSourceTypeForConnector } from '#pplx/frontend/apps/ask/connectors/utils/connectors.js';
import { PLUS_MENU_ITEM_SELECTED_EVENT_NAME, plusMenuItemSelectedEvent, } from '#pplx/frontend/apps/ask/events/ask-input-plus-menu/analytics.js';
import { OAuthIncompleteError } from '#pplx/frontend/apps/ask/oauth-redirect/openRedirectUrl.js';
import { useSourceMeta } from '#pplx/frontend/apps/ask/sources/hooks/useSourceMeta.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import React, { useCallback } from 'react';
export const AskInputPlusMenuFileConnector = React.memo(function AskInputPlusMenuFileConnector({ connectorId, connected, onFilesSelected, gateUploadFile, }) {
    const reason = 'sources-menu-attach-file-connector';
    const { label, getIcon } = useSourceMeta({ sourceId: connectorId });
    const { handleConnect } = useFileConnectorUrl({ reason });
    const currentPath = usePathname();
    const { track } = useInstrumentation();
    const handleFilesSelected = useCallback((connectorFiles) => {
        switch (connectorFiles.type) {
            case 'google_drive':
                onFilesSelected(connectorFiles.files, 'google_drive');
                break;
            case 'onedrive':
                onFilesSelected(connectorFiles.files, 'onedrive');
                break;
            case 'sharepoint':
                onFilesSelected(connectorFiles.files, 'sharepoint');
                break;
            case 'dropbox':
                onFilesSelected(connectorFiles.files, 'dropbox');
                break;
            case 'box':
                onFilesSelected(connectorFiles.files, 'box');
                break;
            default:
                assertUnreachableValue(connectorFiles);
        }
    }, [onFilesSelected]);
    const { openFilePicker, isReady } = useConnectorFilePicker({
        connectorId,
        onFilesSelected: handleFilesSelected,
    });
    const connectAccount = useCallback(() => {
        const attempt = () => {
            handleConnect({
                connectorName: connectorId,
                redirectPath: currentPath || undefined,
                unauthedRedirectPath: currentPath || undefined,
                retry: { run: attempt, surface: 'plus_menu' },
            }).catch((error) => {
                if (error instanceof OAuthIncompleteError)
                    return;
                logger.error('Failed to connect file connector from the plus menu', error);
            });
        };
        attempt();
    }, [connectorId, currentPath, handleConnect]);
    const handleSelect = useCallback(() => {
        const open = () => {
            if (!connected) {
                connectAccount();
                return;
            }
            openFilePicker();
        };
        const gateError = gateUploadFile(fileUploadSourceTypeForConnector(connectorId));
        const gated = Boolean(gateError);
        track(plusMenuItemSelectedEvent({
            name: PLUS_MENU_ITEM_SELECTED_EVENT_NAME,
            data: {
                item: 'cloud_file_connector',
                value: connectorId,
                connected,
                gated,
            },
        }));
        if (gateError)
            return;
        open();
    }, [connected, connectAccount, connectorId, gateUploadFile, openFilePicker, track]);
    const trailingAccessory = !connected ? (_jsx(Icon, { icon: $icon('arrow-up-right'), size: "small" })) : undefined;
    return (_jsx(DropdownMenu.Item, { disabled: connected && !isReady, onSelect: handleSelect, leadingAccessory: getIcon(), trailingAccessory: trailingAccessory, children: label }));
});
//# sourceMappingURL=AskInputPlusMenuFileConnector.js.map